import React from 'react';
import ButtonBase from '@mui/material/ButtonBase';
import './flipCard.css';

// Presentation only. Each game owns pair resolution, timing, and measurements.
export default function FlipCard({ open, matched = false, disabled = false, front, back,
  className = '', sx, ...props }) {
  const showing = open || matched;
  return <ButtonBase {...props} disableRipple disabled={disabled || showing}
    aria-pressed={showing} className={`mini-task-flip-card ${className} ${showing ? 'is-open' : ''} ${matched ? 'is-matched' : ''}`} sx={sx}>
    <span className="mini-task-flip-turn">
      <span className="mini-task-flip-back" aria-hidden="true">{back}</span>
      <span className="mini-task-flip-front" aria-hidden="true">{showing && front}</span>
    </span>
  </ButtonBase>;
}
